module.exports = __webpack_public_path__ + "img/share.da080e6a.png";